import { stringToArray } from './common-functions';

export function isAlphanumeric ( value, allowEmpty = false ) {

    let desired = true;
    let format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

    if ( typeof value !== 'object' && value !== undefined ) {

        if ( allowEmpty ) format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

        desired = !( format.test( value ) );

    }
    return desired;

}

export function isPartNumberValid ( value ) {

    let desired = true;
    let format;

    if ( typeof value !== 'object' && value !== undefined ) {

        format = /[ !@#$%^&*()+=[\]{};':"\\|,.<>?]/;

        desired = !( format.test( value ) );

    }
    return desired;

}
export function isSupplierIdValid ( value ) {

    let desired = true;
    let format;

    if ( typeof value !== 'object' && value !== undefined ) {

        format = /[ !@#$%^&*()+=[\]{};':"\\|,.<>?]/;

        desired = !( format.test( value ) );

    }
    return desired;

}

export function isModelCdValid ( value ) {

    let desired = true;
    let format;

    if ( typeof value !== 'object' && value !== undefined ) {

        format = /[ !@#$%^&*()+=[\]{};':"\\|,.<>?]/;

        desired = !( format.test( value ) );

    }
    return desired;

}

export function filterEmpty ( entries ) {

    const arr = stringToArray( entries );
    const cleanArr = arr.filter( el => el !== null && el.trim() !== '' );
    cleanArr.forEach( ( element, index ) => {

        cleanArr[index] = element.trim();

    } );
    return cleanArr;

}

export function isOnlyNumeric ( value ) {

    let desired = true;
    if ( typeof value !== 'object' && value !== undefined ) {

        const format = /^[0-9]*$/;


        desired = ( format.test( value ) );

    }
    return desired;

}

export function validatePinOrPip ( value ) {

    const validPinOrPip = value;


    if ( validPinOrPip === '' || ( validPinOrPip.length !== 13 && validPinOrPip.length !== 17 ) ) {

        return false;

    }
    return true;

}

export function validatePartNumber ( value ) {

    const validPartNo = value;

    if ( validPartNo === '' || validPartNo.length !== 12 ) {

        return false;

    }
    return true;

}
export function validateSupplierId ( value ) {

    const validSuppliedrId = value;

    if ( validSuppliedrId === '' || validSuppliedrId.length !== 12 ) {

        return false;

    }
    return true;

}
